import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IonTextarea, ModalController } from '@ionic/angular';

import { Ticket, TicketItem } from 'src/app/models';

export type NotesModalResult = string;

export interface NotesModalProps {
  label: string;
  selectedTicket?: Ticket;
  selectedTicketItem?: TicketItem;
}

@Component({
  templateUrl: './notes.modal.html',
  styleUrls: ['./notes.modal.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotesModal implements OnInit, AfterViewInit {
  @Input() label!: string;
  @Input() selectedTicket?: Ticket;
  @Input() selectedTicketItem?: TicketItem;

  @ViewChild('notesInput') notesInput?: IonTextarea;

  private readonly controls = {
    notes: new FormControl(null, Validators.required)
  };

  form = new FormGroup(this.controls);

  constructor(private readonly modalCtrl: ModalController) {}

  ngOnInit() {
    const notes = this.selectedTicketItem
      ? this.selectedTicketItem.notes
      : this.selectedTicket?.delivery_note || '';

    this.controls.notes.setValue(notes);
    this.form.markAsPristine();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.notesInput?.setFocus(), 300);
  }

  onSaveNotes() {
    if (this.form.invalid) {
      return;
    }

    this.onCloseModal(this.form.value.notes);
  }

  onCloseModal(note?: string) {
    this.modalCtrl.dismiss(note?.trim());
  }
}
